export default "__VITE_ASSET__be7b1e82__"